
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 106 106"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","transform":"translate(2 2)"}},[_c('circle',{attrs:{"cx":"49.862","cy":"49.862","r":"49.862","stroke":"currentColor","stroke-width":"5"}}),_c('path',{attrs:{"fill":"currentColor","d":"M45.223 25.511H54.5v34.787h-9.277z"}}),_c('circle',{attrs:{"cx":"49.862","cy":"69.574","r":"4.638","fill":"currentColor"}})])])
      }
    
      }
    